<template>
  <div class="autorization-row">
    <div class="autorization-row-left">
      <div class="autorization-row-checkbox">
        <b-form-checkbox v-model="selectedIds" :value="item.id"/>
      </div>
      <div class="autorization-row-info">
        <Tooltip class="autorization-row-tooltip" :title="item.recipientName">
          <div class="autorization-row-recipient" @click="$emit('edit', item)">
            {{ item.recipientName }}

          </div>
        </Tooltip>
        <Tooltip class="autorization-row-tooltip" :title="descriptionText">
          <div class="autorization-row-description" v-html="item.description"></div>
        </Tooltip>
      </div>
    </div>

    <div class="autorization-row-duedate">
      <div class="autorization-row-date-line">
        <i class="fa-solid fa-calendar-day"></i>
        <span class="autorization-row-date-text">{{ item.dueDate }}</span>
      </div>
      <div class="autorization-row-date-line" v-if="paymentDate">
        <i class="fa-solid fa-circle-check autorization-row-paid-icon"></i>
        <span class="autorization-row-date-text">{{ paymentDate }}</span>
      </div>
    </div>

    <div class="autorization-row-user">
      <div class="user-line">
        <i class="fa-solid fa-user" ></i>
        <span class="user-text">{{ item.registeredUser }}</span>
      </div>
      <div class="user-line" v-if="item.approvedBy && isAuthorized">
        <i class="fa-sharp fa-solid fa-circle-check approved-icon"></i>
        <span class="user-text">{{ item.approvedBy }}</span>
      </div>
    </div>

    <div class="autorization-row-value">
      {{ item.value | currency }}
    </div>

    <div class="autorization-row-status">
      <Tooltip v-if="isRejected" :title="rejectionTooltip" placement="left">
        <Badge :title="item.statusName" :type="statusType(item.statusName)" size="medium"/>
      </Tooltip>
      <Badge
          v-else-if="item.statusName"
          :title="item.statusName"
          :type="statusType(item.statusName)"
          size="medium"
      />
    </div>
  </div>
</template>

<script>
import Tooltip from "@/ui/layout/Tooltip";
import Badge from "@/ui/layout/Badge.vue";
import {mapMutations} from "vuex";

export default {
  name: "AutorizationRow",
  components: {Tooltip, Badge},
  props: {
    item: {type: Object, required: true},
  },
  computed: {
    selectedIds: {
      get() {
        return this.$store.state.generic.selected;
      },
      set(value) {
        this.addSelected(value);
      },
    },
    paymentDate() {
      return this.item.paymentDate || this.item.conciliationDate || "";
    },
    descriptionText() {
      if (!this.item.description) return "";
      return String(this.item.description)
          .replace(/<[^>]*>/g, " ")
          .replace(/&nbsp;/g, " ")
          .replace(/\s+/g, " ")
          .trim();
    },
    isAuthorized() {
      return this.item.statusName === "Autorizada";
    },
    isRejected() {
      return this.item.statusName === "Não Autorizada";
    },
    rejectionTooltip() {
      const parts = [];
      if (this.item.rejectionReason) parts.push(`Motivo: ${this.item.rejectionReason}`);
      if (this.item.approvedBy) parts.push(`Reprovado por: ${this.item.approvedBy}`);
      return parts.join("\n");
    },
  },
  methods: {
    ...mapMutations("generic", ["addSelected"]),
    statusType(statusName) {
      if (!statusName) return "info";
      const s = String(statusName).toLowerCase();
      if (s === "autorizada") return "success";
      if (s === "não autorizada" || s === "não autorizada") return "danger";
      return "warning";
    },
  },
};
</script>

<style scoped>
.autorization-row {
  display: grid;
  grid-template-columns: 1fr 130px 130px 130px 130px;
  align-items: center;
  gap: 12px;
  padding: 10px 16px;
  border-top: 1px solid var(--border-subtle);
  box-sizing: border-box;
  transition: background 0.15s;
}

.autorization-row:hover {
  background: var(--bg-elevated);
}

.autorization-row-left {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.autorization-row-checkbox {
  flex-shrink: 0;
}

.autorization-row-info {
  flex: 1 1 0;
  min-width: 0;
}

.autorization-row-recipient {
  font-size: 13px;
  font-weight: 600;
  color: var(--text-primary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
  transition: color 0.15s;
}

.autorization-row-recipient:hover {
  color: var(--color-brand);
}

.autorization-row-description {
  font-size: 12px;
  color: var(--text-secondary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.autorization-row-description ::v-deep p,
.autorization-row-description ::v-deep div,
.autorization-row-description ::v-deep ul,
.autorization-row-description ::v-deep ol {
  display: inline;
  margin: 0;
  padding: 0;
}

.autorization-row-description ::v-deep br,
.autorization-row-description ::v-deep img {
  display: none;
}

.autorization-row-tooltip {
  display: block;
  min-width: 0;
}

.autorization-row-duedate,
.autorization-row-user {
  font-size: 13px;
  color: var(--text-secondary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.user-line,
.autorization-row-date-line {
  display: flex;
  align-items: center;
  gap: 6px;
}

.autorization-row-date-text {
  overflow: hidden;
  text-overflow: ellipsis;
}

.autorization-row-paid-icon {
  color: var(--color-success);
}

.user-text {
  overflow: hidden;
  text-overflow: ellipsis;
}

.approved-icon {
  color: #37A169;
}

.autorization-row-value {
  font-size: 15px;
  font-weight: 700;
  color: var(--color-danger);
  text-align: center;
  white-space: nowrap;
}

.autorization-row-status {
  display: flex;
  justify-content: center;
  padding-right: 16px;
}
</style>
